/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { UserManagementResetPasswordResponse } from "./UserManagementResetPasswordResponse";

export type UserManagementResetPasswordResponseApiRespoonse = {
  data?: UserManagementResetPasswordResponse;
  status?: UserManagementResetPasswordResponseApiRespoonse.status;
  message?: string;
  errors?: Record<string, Array<string>>;
};

export namespace UserManagementResetPasswordResponseApiRespoonse {
  export enum status {
    SUCCESS = "success",
    ERROR = "error",
  }
}
